(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["klockcraft-product"] && !Shopify.designMode) return;
  try {
    
  const initializeKlockCraft = (root = document) => {
    root.querySelectorAll('[data-kcp-root]').forEach((section) => {
      if (section.dataset.kcpReady === 'true') return;
      section.dataset.kcpReady = 'true';

      const form = section.querySelector('[data-kcp-form]');
      const mainImage = section.querySelector('[data-kcp-main-image]');
      const mainMedia = section.querySelector('[data-kcp-main-media]');
      const thumbs = section.querySelectorAll('[data-kcp-thumb]');
      const optionSelects = section.querySelectorAll('[data-kcp-option]');
      const variantInput = section.querySelector('[data-kcp-variant-id]');
      const addButton = section.querySelector('[data-kcp-add]');
      const addLabel = section.querySelector('[data-kcp-add-label]');
      const finalButton = section.querySelector('[data-kcp-final-submit]');
      const finalLabel = section.querySelector('[data-kcp-final-label]');
      const mobileBar = section.querySelector('[data-kcp-mobile-buy]');
      const mobileButton = section.querySelector('[data-kcp-mobile-submit]');
      const mobileLabel = section.querySelector('[data-kcp-mobile-label]');
      const status = section.querySelector('[data-kcp-status]');
      const priceNodes = section.querySelectorAll('[data-kcp-price]');
      const compareNode = section.querySelector('[data-kcp-compare]');
      const variantData = section.querySelector('[data-kcp-variants]');
      const variants = variantData ? JSON.parse(variantData.textContent) : [];
      const quantityInput = section.querySelector('[data-kcp-quantity]');
      const bundleInputs = section.querySelectorAll('[data-kcp-bundle]');
      const bundleTotals = section.querySelectorAll('[data-kcp-bundle-total]');
      const addText = section.dataset.addLabel;
      const soldOutText = section.dataset.soldOutLabel;
      const unavailableText = section.dataset.unavailableLabel;
      const loadingText = section.dataset.loadingLabel;
      let statusTimer;

      if (!form || !addButton || !variantInput) return;

      const showStatus = (message) => {
        if (!status || !message) return;
        window.clearTimeout(statusTimer);
        status.textContent = message;
        status.classList.add('is-visible');
        statusTimer = window.setTimeout(() => status.classList.remove('is-visible'), 3200);
      };

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          if (!mainImage) return;
          const updateImage = () => {
            mainImage.removeAttribute('srcset');
            mainImage.removeAttribute('sizes');
            mainImage.src = thumb.dataset.mediaSrc;
            mainImage.alt = thumb.dataset.mediaAlt || '';
            thumbs.forEach((item) => {
              const active = item === thumb;
              item.classList.toggle('is-active', active);
              item.setAttribute('aria-pressed', String(active));
            });
            mainMedia?.classList.add('is-changing');
            window.setTimeout(() => mainMedia?.classList.remove('is-changing'), 180);
          };
          if (document.startViewTransition) document.startViewTransition(updateImage);
          else updateImage();
        });
      });

      const updateBuyState = (variant) => {
        const available = Boolean(variant?.available);
        const label = variant ? (available ? addText : soldOutText) : unavailableText;
        variantInput.value = variant?.id || '';
        addButton.disabled = !available;
        if (finalButton) finalButton.disabled = !available;
        if (mobileButton) mobileButton.disabled = !available;
        if (addLabel) addLabel.textContent = label;
        if (finalLabel) finalLabel.textContent = label;
        if (mobileLabel) mobileLabel.textContent = available ? section.dataset.addLabel : label;
        if (!variant) return;
        priceNodes.forEach((node) => { node.textContent = variant.price; });
        if (compareNode) {
          compareNode.hidden = !variant.compareAt;
          compareNode.textContent = variant.compareAt || '';
        }
      };

      const syncVariant = () => {
        const selectedOptions = Array.from(optionSelects).map((select) => select.value);
        const variant = optionSelects.length === 0
          ? variants.find((item) => String(item.id) === String(variantInput.value)) || variants[0]
          : variants.find((item) => item.options.every((option, index) => option === selectedOptions[index]));
        updateBuyState(variant);
      };
      optionSelects.forEach((select) => select.addEventListener('change', syncVariant));

      const selectBundle = (input) => {
        if (!input || !quantityInput) return;
        const quantity = Math.max(1, Math.min(3, Number(input.dataset.bundleQuantity) || 1));
        quantityInput.value = String(quantity);
        input.checked = true;
        bundleTotals.forEach((node) => { node.textContent = input.dataset.bundlePrice; });
      };

      const syncBundleFromQuantity = () => {
        if (!quantityInput) return;
        const quantity = Math.max(1, Math.min(3, Number(quantityInput.value) || 1));
        quantityInput.value = String(quantity);
        const input = Array.from(bundleInputs).find((item) => Number(item.dataset.bundleQuantity) === quantity);
        if (input) selectBundle(input);
      };

      bundleInputs.forEach((input) => input.addEventListener('change', () => selectBundle(input)));
      selectBundle(Array.from(bundleInputs).find((input) => input.checked) || bundleInputs[0]);

      section.querySelector('[data-kcp-quantity-minus]')?.addEventListener('click', () => {
        const minimum = Number(quantityInput?.min || 1);
        if (quantityInput) quantityInput.value = String(Math.max(minimum, Number(quantityInput.value || 1) - 1));
        syncBundleFromQuantity();
      });
      section.querySelector('[data-kcp-quantity-plus]')?.addEventListener('click', () => {
        const maximum = Number(quantityInput?.max || 3);
        if (quantityInput) quantityInput.value = String(Math.min(maximum, Math.max(1, Number(quantityInput.value || 1) + 1)));
        syncBundleFromQuantity();
      });
      quantityInput?.addEventListener('change', syncBundleFromQuantity);

      form.addEventListener('submit', async (event) => {
        const klockCraftCart = section.querySelector('klockcraft-cart-drawer');
        if (klockCraftCart?.isReady) return;
        const cartSurface = document.querySelector('cart-drawer, cart-notification');
        if (!cartSurface || typeof cartSurface.renderContents !== 'function') return;
        event.preventDefault();
        if (addButton.disabled) return;

        const formData = new FormData(form);
        if (typeof cartSurface.getSectionsToRender === 'function') {
          const sections = cartSurface.getSectionsToRender().map((item) => item.id || item.section).filter(Boolean);
          formData.set('sections', sections.join(','));
          formData.set('sections_url', window.location.pathname);
        }
        if (typeof cartSurface.setActiveElement === 'function') cartSurface.setActiveElement(addButton);

        addButton.disabled = true;
        addButton.setAttribute('aria-busy', 'true');
        if (addLabel) addLabel.textContent = loadingText;

        try {
          const response = await fetch(window.routes?.cart_add_url || `${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: formData
          });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || unavailableText);
          cartSurface.classList.remove('is-empty');
          cartSurface.renderContents(result);
        } catch (error) {
          showStatus(error.message || unavailableText);
        } finally {
          addButton.removeAttribute('aria-busy');
          syncVariant();
        }
      });

      mobileButton?.addEventListener('click', () => form.requestSubmit());
      finalButton?.addEventListener('click', () => form.requestSubmit());

      if (mobileBar && 'IntersectionObserver' in window) {
        const buyObserver = new IntersectionObserver(([entry]) => {
          mobileBar.classList.toggle('is-visible', !entry.isIntersecting);
        }, { threshold: .12 });
        buyObserver.observe(form);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeKlockCraft(document), { once: true });
  } else {
    initializeKlockCraft(document);
  }
  document.addEventListener('shopify:section:load', (event) => initializeKlockCraft(event.target));

  } catch(e) { console.error(e); }
})();
})();
